import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import { vec2, vec3 } from "_src/libs/gl-matrix";

import vertText from "_src/shaders/wireframe/wireframe.glslv";
import fragText from "_src/shaders/wireframe/wireframe.glslf";

const _vec3Tmp = vec3.create();

export default class WireframeShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);

    this.primitiveIDTexture = params.primitiveIDTexture ? params.primitiveIDTexture : null;

  }

  compile() {
    super.compile(vertText, fragText);
  }

  updateSceneUniformValues(scene)   {
    const camera = scene.camera;
    vec2.copy(this.uniforms["u_texel_size"].value, camera.texelSize);
  }

  attachUniforms(params) {

    const wireframeColor = params.wireframeColor ?
        new Float32Array(params.wireframeColor) :
        new Float32Array([1.0, 0.0, 0.0]);

    this.uniforms["tPrimitiveID"] = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_wireframe"]  = new Uniform(uniformType.FLOAT3, wireframeColor);
    this.uniforms["u_texel_size"] = new Uniform(uniformType.FLOAT2, vec2.create(), uniformSource.SCENE);

  }

  setColor(r, g, b) {
    const color = vec3.set(_vec3Tmp, r, g, b);
    this.setUniform("u_wireframe", color);
  }

}
